import React, { Component } from "react";
import "./shadcnButton.module.css";

export default class ShadcnButton extends Component {
  render() {
    const {
      children,
      variant = "default",
      size = "default",
      className = "",
      disabled = false,
      type = "button",
      ...props
    } = this.props;

    const classes = [
      "uiButton",
      `uiButton--${variant}`,
      `uiButton--${size}`,
      disabled ? "uiButton--disabled" : "",
      className,
    ].join(" ");

    return (
      <button
        type={type}
        className={classes}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/components/button/ShadcnButton.js